import React from 'react';
import { FaShare, FaGlobe, FaSearch, FaUsers, FaExternalLinkAlt } from 'react-icons/fa';

const ReferrerAnalytics = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-32 text-gray-400">
        <p>No referrer data available</p>
      </div>
    );
  }

  const totalClicks = data.reduce((sum, item) => sum + item.count, 0);
  const topReferrers = data.slice(0, 8); // Show top 8 referrers

  const getReferrerIcon = (referrer) => {
    const lowerReferrer = referrer.toLowerCase();
    
    if (referrer === 'Direct') {
      return <FaGlobe className="w-5 h-5 text-gray-400" />;
    }
    
    if (lowerReferrer.includes('google')) {
      return <FaSearch className="w-5 h-5 text-blue-500" />;
    }
    
    if (lowerReferrer.includes('facebook') || lowerReferrer.includes('twitter') || 
        lowerReferrer.includes('instagram') || lowerReferrer.includes('linkedin') ||
        lowerReferrer.includes('youtube') || lowerReferrer.includes('tiktok')) {
      return <FaUsers className="w-5 h-5 text-purple-500" />;
    }
    
    return <FaExternalLinkAlt className="w-5 h-5 text-indigo-500" />;
  };

  const getReferrerLabel = (referrer) => {
    if (referrer === 'Direct') {
      return 'Direct Access';
    }
    
    try {
      const url = new URL(referrer);
      return url.hostname.replace('www.', '');
    } catch {
      return referrer.length > 30 ? referrer.substring(0, 30) + '...' : referrer;
    }
  };

  const getReferrerColor = (index) => {
    const colors = [
      'bg-gray-500',
      'bg-blue-500',
      'bg-green-500',
      'bg-purple-500',
      'bg-yellow-500',
      'bg-red-500',
      'bg-indigo-500',
      'bg-pink-500'
    ];
    return colors[index % colors.length];
  };

  const getReferrerType = (referrer) => {
    const lowerReferrer = referrer.toLowerCase();
    
    if (referrer === 'Direct') {
      return 'Direct';
    }
    
    if (lowerReferrer.includes('google')) {
      return 'Arama Motoru';
    }
    
    if (lowerReferrer.includes('facebook') || lowerReferrer.includes('twitter') || 
        lowerReferrer.includes('instagram') || lowerReferrer.includes('linkedin') ||
        lowerReferrer.includes('youtube') || lowerReferrer.includes('tiktok')) {
      return 'Sosyal Medya';
    }
    
    return 'Web Sitesi';
  };

  return (
    <div className="flex flex-col h-full">
      <div className="space-y-4 flex-grow">
        {topReferrers.map((item, index) => (
        <div key={index} className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            {getReferrerIcon(item.referrer)}
            <div className="min-w-0 flex-1">
              <div className="text-white font-medium truncate" title={item.referrer}>
                {getReferrerLabel(item.referrer)}
              </div>
              <div className="text-sm text-gray-400">
                {item.count} clicks • {getReferrerType(item.referrer)}
              </div>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            <div className="text-right">
              <div className="text-white font-semibold">{item.percentage}%</div>
            </div>
            
            <div className="w-24 bg-gray-700 rounded-full h-2">
              <div 
                className={`h-2 rounded-full ${getReferrerColor(index)} transition-all duration-300`}
                style={{ width: `${item.percentage}%` }}
              ></div>
            </div>
          </div>
        </div>
        ))}
        
        {/* Show "Others" if there are more than 8 referrers */}
        {data.length > 8 && (
          <div className="flex items-center justify-between pt-2 border-t border-gray-700">
            <div className="flex items-center space-x-3">
              <FaShare className="w-5 h-5 text-gray-400" />
              <div className="text-left">
                <div className="text-white font-medium">Other Sources <span className="text-sm text-gray-400">({data.slice(8).reduce((sum, item) => sum + item.count, 0)} clicks)</span></div>
              </div>
            </div>
            
            <div className="flex items-center space-x-3">
              <div className="text-right">
                <div className="text-white font-semibold">
                  {Math.round((data.slice(8).reduce((sum, item) => sum + item.count, 0) / totalClicks) * 100)}%
                </div>
              </div>
              
              <div className="w-24 bg-gray-700 rounded-full h-2">
                <div 
                  className="h-2 rounded-full bg-gray-500 transition-all duration-300"
                  style={{ 
                    width: `${Math.round((data.slice(8).reduce((sum, item) => sum + item.count, 0) / totalClicks) * 100)}%` 
                  }}
                ></div>
              </div>
            </div>
          </div>
        )}
      </div>
      
      {/* Summary */}
      <div className="mt-6 pt-4 border-t border-gray-700">
        <div className="grid grid-cols-2 gap-4">
          <div className="text-left">
            <div className="text-2xl font-bold text-white">{totalClicks}</div>
            <div className="text-sm text-gray-400">Total Clicks</div>
          </div>
          <div className="text-left">
            <div className="text-2xl font-bold text-white">{data.length}</div>
            <div className="text-sm text-gray-400">Different Sources</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferrerAnalytics;
